<template>
  <div>
    <!-- 试玩页 -->
    <div v-if="formKey === 'wxgame_playable_page_path'">
      <el-button type="primary" @click="() => openAssignWxgamePlayablePagePath(formItem)">选择小游戏试玩页</el-button>
      <div v-if="Object.keys(formItem.value || {}).length">
        <div v-for="(item, key) in Object.values(formItem.value)[0]" :key="key">
          <span v-show="item.name" class="mr-10">{{ item.name }}</span>
          <span v-show="item.nick_name" class="mr-10">{{ item.nick_name }}</span>
          <span>{{ item.url || '' }}</span>
        </div>
      </div>
      <el-dialog
        title="小游戏试玩页配置"
        :visible.sync="formItem.is_open"
        :close-on-click-modal="false"
        :append-to-body="true"
        :modal-append-to-body="true"
        width="800px"
      >
        <wxgame-playable-page-path-list v-if="formItem.is_open" :form-item="formItem" v-bind="getComponentProps(formKey)" />
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="formItem.is_open = false">取 消</el-button>
          <el-button size="mini" type="primary" @click="() => confirmAssignWxgamePlayablePagePath(formItem)">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 试玩结束封面图 -->
    <div v-if="formKey === 'wxgame_playable_page_end_cover_img'">
      <div class="flex">
        <el-image v-show="formItem.value" class="mr-10 icon inline-block" fit="cover" :src="formItem.value" />
        <div>
          <el-button v-if="!formItem.isPreview" size="mini" type="primary" @click="openMaterialBox('image', formItem)">{{ formItem.value ? '替换' : '添加' }}封面</el-button>
        </div>
      </div>
      <!-- 素材弹框 -->
      <material-box
        v-if="formItem.is_open"
        advertiser="gdt"
        :is-open="formItem.is_open"
        :type="formItem.box_type"
        :temp-material="formItem.temp_material"
        :material-restriction="formItem.material_restriction"
        @confirm="(m_data) => materialConfirm({ data: m_data, material: formItem })"
        @cancel="materialCancel(formItem)"
      />
    </div>
  </div>
</template>

<script>
export default {
  components: {
    'material-box': () => import('@/components/material-box'),
    'wxgame-playable-page-path-list': () => import('@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/components/creative-config/creative-components/channel-interface/gdt/components/wxgame-playable-page-path/components/wxgame-playable-page-path-list/index.vue'),
  },
  props: {
    // 表单项键名
    formKey: {
      type: String,
      required: true,
    },
    // 表单项配置
    formItem: {
      type: Object,
      required: true,
    },
    // 初始化数据
    initOps: {
      type: Object,
      required: true,
    },
    row: {
      type: Object,
      required: true,
    },
  },
  created() {

  },
  methods: {
    /**
     * 获取组件props
     * @param {string} form_key 表单键
     * @returns {Object}
     */
    getComponentProps(form_key) {
      const strategy = {
        wxgame_playable_page_path: () => {
          const { advertiser_id, campaign: { delivery_content_id }} = this.row;

          return {
            advertiserId: advertiser_id,
            deliveryContentId: delivery_content_id,
          };
        },
        default: () => {},
      };

      return (strategy[form_key] || strategy['default'])();
    },
    /**
     * 打开试玩页配置
     * @param form_item 表单项
     * @returns {void}
     */
    openAssignWxgamePlayablePagePath(form_item) {
      form_item.assignSelection = {};
      form_item.is_open = true;
    },
    /**
     * 试玩页配置弹窗确认
     * @param form_item 表单项
     * @returns {void}
     */
    confirmAssignWxgamePlayablePagePath(form_item) {
      const result = JSON.parse(JSON.stringify(form_item.assignSelection));
      const is_valid = Object.values(result).every(v => v.length);
      if (is_valid) {
        form_item.value = JSON.parse(JSON.stringify(form_item.assignSelection));
        form_item.is_open = false;
        this.$parent.$parent.$parent.$parent.$parent.validateField('wxgame_playable_page.children.wxgame_playable_page_path.value');
      } else {
        this.$message.warning('请填写完整所有配置');
      }
    },
    /**
     * 打开素材框
     * @param {string} type 素材类型
     * @param {string} material_item 当前素材
     * @returns {void}
     */
    openMaterialBox(type, material_item) {
      if (material_item) {
        material_item.temp_material = null;
        material_item.is_open = true;
        material_item.box_type = material_item.element_type || type;
      }
    },
    /**
     * 素材资源确定返回
     * @param {Array<Object>} data 素材数据
     * @param {Object} material 表单配置项
     * @returns {void}
     */
    async materialConfirm({ data, material }) {
      material.is_open = false;

      if (data.length === 0) {
        return;
      }

      if ((data.length > material.limit) && !material.temp_material) {
        this.$message.warning(`试玩结束封面图不能超过${material.limit}个！`);
        return;
      }
      material.value = data[0].url[0].url;
      this.$parent.$parent.$parent.$parent.$parent.validateField('wxgame_playable_page.children.wxgame_playable_page_end_cover_img.value');
    },
    /**
     * 素材资源取消返回
     * @param {Object} material 素材配置项
     * @returns {void}
     */
    materialCancel(material) {
      material.is_open = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  width: 100px;
  height: 100px;
  font-size: 0;
}
</style>
